import { MessageSortByParam } from "@bvhi/backend-api";
import { GridSortItem } from "@bvhi/ui-base";
import { useCallback } from "react";

export interface SortConfig {
  backendString: string;
  dataGridSortModel: GridSortItem;
}

const config: SortConfig[] = [
  {
    backendString: MessageSortByParam.CREATED_AT_ASC,
    dataGridSortModel: {
      field: "createdAt",
      sort: "asc",
    },
  },
  {
    backendString: MessageSortByParam.CREATED_AT_DESC,
    dataGridSortModel: {
      field: "createdAt",
      sort: "desc",
    },
  },
  {
    backendString: MessageSortByParam.CUSTOMER_NUMBER_ASC,
    dataGridSortModel: {
      field: "customerNumber",
      sort: "asc",
    },
  },
  {
    backendString: MessageSortByParam.CUSTOMER_NUMBER_DESC,
    dataGridSortModel: {
      field: "customerNumber",
      sort: "desc",
    },
  },
  {
    backendString: MessageSortByParam.SUPPLIER_CODE_ASC,
    dataGridSortModel: {
      field: "supplierCode",
      sort: "asc",
    },
  },
  {
    backendString: MessageSortByParam.SUPPLIER_CODE_DESC,
    dataGridSortModel: {
      field: "supplierCode",
      sort: "desc",
    },
  },
];

export const useMessagesSortParams = () => {
  const isFieldSortable = useCallback((fieldName: string): boolean => {
    const configItem = config.find((item) => item.dataGridSortModel.field === fieldName);
    if (configItem) return true;
    return false;
  }, []);

  const getSortModelForBackendString = useCallback((backendString: string): GridSortItem => {
    const item = config.find((item) => item.backendString === backendString);
    return item?.dataGridSortModel ?? config[0].dataGridSortModel;
  }, []);

  const getSortConfig = useCallback((sortModel?: GridSortItem) => {
    if (!sortModel) return config[0];
    const item = config.find((item) => item.dataGridSortModel.field === sortModel.field && item.dataGridSortModel.sort === sortModel.sort);
    return item ?? config[0];
  }, []);

  return { isFieldSortable, getSortConfig, getSortModelForBackendString };
};
